<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newNotification()"
                aria-label="Add notification">
            {{'Add notification'|translate}}
        </button>
    </div>

    <div class="nav material2">
        <div class="nav-item">

        </div>
    </div>

</div>
<!-- / SIDEBAR CONTENT -->
